import { render, staticRenderFns } from "./Involvement.vue?vue&type=template&id=5b0e2376&"
import script from "./Involvement.vue?vue&type=script&lang=js&"
export * from "./Involvement.vue?vue&type=script&lang=js&"
import style0 from "./Involvement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports